import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import {
  AnotherCrmType,
  CreateNeuronCrmIntegrationRequest,
} from '../components/layout/right-sidebar/components/neuron/another-crm/neuron-and-another-crm.interface';
import { ANOTHER_CRM_TYPE } from '../enum/constants';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NeuronAndAnotherCrmService {
  constructor(private readonly http: HttpClient, private readonly baseService: BaseService) {
  }

  public readonly anotherCrmTypes: AnotherCrmType[] = [
    {
      name: 'another_crm.key_crm',
      value: ANOTHER_CRM_TYPE.KEY_CRM,
      img: '/assets/images/other/ic_keycrm.png',
      hidden: false,
    },

    {
      name: 'another_crm.sales_drive',
      value: ANOTHER_CRM_TYPE.SALES_DRIVE,
      img: '/assets/images/other/ic_sales_drive.png',
      hidden: false,
    },

    {
      name: 'another_crm.keepincrm',
      value: ANOTHER_CRM_TYPE.KEEPINCRM,
      img: '/assets/images/other/ic_keepincrm.png',
      hidden: false,
    },
  ].filter(v => !v.hidden);

  public getIntegration() {
    return this.http.get<any>(environment.baseURL + '/neuron/crm-integration')
      .pipe(map(v => v.data));
  }

  public createIntegration(payload: CreateNeuronCrmIntegrationRequest) {
    return this.http.post<any>(environment.baseURL + '/neuron/crm-integration', payload)
      .pipe(map(v => v.data));
  }

  public deleteIntegration() {
    return this.http.delete<any>(environment.baseURL + '/neuron/crm-integration')
      .pipe(map(v => v.data));
  }

  public getWebhookUrl(anotherCrmType: ANOTHER_CRM_TYPE): string | undefined {
    let whType = '';
    switch (anotherCrmType) {
      case ANOTHER_CRM_TYPE.KEY_CRM: {
        whType = 'key-crm';
        break;
      }
      case ANOTHER_CRM_TYPE.SALES_DRIVE: {
        whType = 'sales-drive';
        break;
      }
      case ANOTHER_CRM_TYPE.KEEPINCRM: {
        whType = 'keepincrm';
        break;
      }

      default: {
        return;
      }
    }

    return `${environment.baseURL}/webhooks/${whType}/${this.baseService.company.id}`;

  }
}
